// src/redux/slices/lead/slice.js
import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { coreReducers } from './coreReducers';
import { treatmentReducers } from './treatmentReducers';
import { appointmentReducers } from './appointmentReducers';
import { taskReducers } from './taskReducers';
import { financialReducers } from './financialReducers';
import { tableReducers } from './tableReducers';

const leadSlice = createSlice({
    name: 'lead',
    initialState,
    reducers: {
        ...coreReducers,
        ...treatmentReducers,
        ...appointmentReducers,
        ...taskReducers,
        ...financialReducers,
        ...tableReducers,
    },
});

export const leadActions = leadSlice.actions;
export default leadSlice.reducer;

// Re-export individual actions for backward compatibility
// This MUST match the exact destructuring from lead.js lines 969-997
export const {
    contactLeadSlice,
    updateBookingSteps,
    newLead,
    clearLead,
    updateCounter,
    updateSteps,
    clearApiData,
    tableLead,
    archivedLeadSlice,
    updateCompleteStatus,
    addTaskSearchLead,
    saveNewLeadDetail,
    savePersonalLeadDetails,
    updateActiveStep,
    clearReminder,
    updateFollowUpLead,
    archiveLead,
    addTaskTableData,
    startLoadingData,
    clearLeadDetail,
    AddLeadNotes,
    saveLeadDetail,
    setLeadDetailNotFound,
    setAssigned,
    upComingTask,
    leadSummaryListingSlice,
    addLeadTaskTab,
    updateTaskCounter,
    updateLeadTaskCounter,
    clearTaskLead,
    leadStatusTreatmentStarted,
    getTaskDetails,
    updateTableType,
    startLoading,
    startArchivedLoading,
    updateDashboardTable,
    updateNewTable,
    updateBookedTable,
    updateFailedToAttendTable,
    updateClosedTable,
    updateAttendTable,
    updateClincheckTable,
    updateAttendedChecklistsTable,
    updateTreatmentStartedTable,
    updateArchiveTable,
    cleanTaskCounter,
    clearAllReminderData,
    updateDashNewLeadsTable,
    updateDashNewLeadsWidgetTable,
    clearDashboardStatusesSummery,
    updateDashNewLead,
    setArchivedLeadTags,
    clearTableData,
    checkoutListingSlice,
    refundListingSlice,
    appointmentNotesSlice,
    updateConsentLink,
    selectLeads,
    clearConsentData,
    reset,
    updateSeparateTaskCounter,
    clearSeparateTaskCounter,
    saveConsentLead,
    setDashboardTaskPageFilter,
    setLeadDetailTaskPageFilter,
    setTaskPageFilter,
    taskCompletedUser,
    updateDateFormat,
    updateconsultationDateFormat,
    updateAttendedDateFormat,
    updateAppointmentDateFormat,
    updateLastContactDateFormat,
    updateArchiveDateFormat,
    duplicateSelectLeads,
    setLoadingForExport,
    setLoadingForLead,
    leadPage,
    startLoadingDepositPending,
    setCurrentTreatmentData,
    setAttendedActiveTab,
    setDepositStatus,
    setTreatmentLoading,
    setTodoListFilter,
    leadFlowReminderData,
    leadFlowReminderMoreData,
    appointmentDateSlice,
    setAction,
    setLoadingApis,
    taskUnassignedUser,
    updateNoTaskTable,
    updateAlignerTable,
    appointmentUserSlice,
    updateSendReminderDuringLeadCreate,
    updateExistingAudienceList,
    followUpLead,
    clearFollowUpTableMoved,
    setDentallyBooking,
    setDentallySlot,
    setDentallyPatientId,
    setPendingDentallySync,
    clearDentallyState,
    mergeCampaignSearchResults,
} = leadSlice.actions;
